import * as React from 'react';
import Project from 'src/entities/Project';
import DocumentContractMiniatureContainer from '../sign-contracts/partials/DocumentContractMiniature.container';
import Investment from 'src/entities/Investment';

interface Props {
  project: Project;
  investment: Investment;
  handleSubmitDocument: (typeDocument: boolean) => void;

  handleModifyDocument(): void;
}

const ReviewContractsComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="col-sm-12">
    <div className="padding-left-30">
      <div className="gap-50"/>
      <div className="gap-20"/>
      <div className="row">
        <div
          className="col-md-6 fa-align-center"
        >
          <p className="jobTitle">
            Acuerdo de sindicación:
          </p>

          <DocumentContractMiniatureContainer
            typeDocument={true}
            action="Confirmar"
            active={props.investment.acceptedSyndicateAgreement!}
            documentFile={props.project.syndicateAgreement!}
            imageFile={props.project.syndicateAgreementImage ? props.project.syndicateAgreementImage!.url! : undefined}
            handleSubmitDocument={(typeDocument: boolean) => props.handleSubmitDocument(typeDocument)}
          />
        </div>
        <div
          className="col-md-6 fa-align-center"
        >
          <p className="jobTitle">
            Pacto de socios:
          </p>
          <DocumentContractMiniatureContainer
            typeDocument={false}
            action="Confirmar"
            active={props.investment.acceptedShareholderAgreement!}
            documentFile={props.project.stakeholderAgreement!}
            imageFile={
              props.project.stakeholderAgreementImage ?
                props.project.stakeholderAgreementImage!.url! :
                undefined
            }
            handleSubmitDocument={props.handleSubmitDocument}
          />
        </div>
      </div>
      <div className="gap-20"/>
      <p className="question-detail">
        (Es posible que para poder descargar los documentos tengas que desactivar tu bloqueador de publicidad.)
      </p>
      <div className="gap-30"/>
      <div className="row">
        <button
          className="btn btn-primary text-center"
          onClick={() => props.handleModifyDocument()}
        >
          Modificar
        </button>
      </div>
    </div>
  </div>
);

export default ReviewContractsComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/review-contracts/ReviewContracts.component.tsx